<template>
  <div class="hint" @mousedown="selectTime">
    {{ value }}
  </div>
</template>

<script>
export default {
  props: ['value'],
  name: 'TimeHint',
  methods: {
    selectTime () {
      this.$emit('timeSelected')
    }
  }
}
</script>

<style>
  .hint {
    display: flex;
    padding: 8px 14px;
    width: 95px;
    align-items: center;
    align-self: stretch;
    cursor: pointer;
  }
  .hint:hover {
    background: #F9FAFB;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/CalendarComponent/TimeHint.vue